import {
  Button,
  makeStyles,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import DialogContentText from "@material-ui/core/DialogContentText";
import ActionDialog from "@saleor/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import { maybe, renderCollection } from "@saleor/misc";
import { StoreDetailPath } from "@saleor/seller/urls";
import React from "react";
import { FormattedMessage } from "react-intl";
import Moment from "react-moment";

import { SellerDetails_brandPrivate_tenants } from "../../types/SellerDetails";

const useStyles = makeStyles(
  theme => ({
    actionColumn: {
      textAlign: "center",
      width: "15%"
    },
    colCompany: {
      width: 250
    },
    colEmail: {
      width: 285
    },
    colRow: {
      "& th": {
        fontWeight: 600 as 600,
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1)
      }
    },
    tableRow: {
      cursor: "pointer"
    },
    wideColumn: {
      width: "60%"
    }
  }),
  { name: "ViewStoreDialog" }
);
interface ViewStoreDialog {
  tenants: SellerDetails_brandPrivate_tenants[];
  action: string;
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  confirmButtonState: ConfirmButtonTransitionState;
}

export const ViewStoreDialog: React.FC<ViewStoreDialog> = props => {
  const { tenants, open, onClose, confirmButtonState, onConfirm } = props;

  const colNumber = 3;
  const classes = useStyles(props);
  return (
    <>
      <ActionDialog
        confirmButtonState={confirmButtonState}
        open={open}
        title="View Stores"
        variant="info"
        onClose={onClose}
        confirmButtonLabel="YES"
        maxWidth="md"
        onConfirm={onConfirm}
      >
        <DialogContentText>
          <ResponsiveTable>
            <TableHead>
              <TableRow className={classes.colRow}>
                <TableCell className={classes.wideColumn}>
                  <FormattedMessage defaultMessage="Store Name" />
                </TableCell>
                <TableCell>
                  <FormattedMessage defaultMessage="Date Created" />
                </TableCell>
                <TableCell className={classes.actionColumn}>
                  <FormattedMessage defaultMessage="Action" />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {renderCollection(
                tenants,
                (tenant, index) => (
                  <TableRow
                    key={tenant ? tenant.id : "skeleton"}
                    hover={!!tenant}
                    className={classes.tableRow}
                    onClick={() => {
                      window.location.href = StoreDetailPath(tenant.id);
                    }}
                  >
                    <TableCell id={`storeNameRow${index}`}>
                      <Typography>
                        {maybe<React.ReactNode>(
                          () => tenant.storeName,
                          <Skeleton />
                        )}
                      </Typography>
                    </TableCell>
                    <TableCell id={`dateCreatedRow${index}`}>
                      <Moment format="MM/DD/YYYY">{tenant?.dateCreated}</Moment>
                    </TableCell>
                    <TableCell align="center" id={`viewStoreBtnRow${index}`}>
                      <Button color="primary" variant="contained">
                        <FormattedMessage defaultMessage="View" />
                      </Button>
                    </TableCell>
                  </TableRow>
                ),
                () => (
                  <TableRow>
                    <TableCell colSpan={colNumber}>
                      <Typography>
                        <FormattedMessage defaultMessage="No Store found" />
                      </Typography>
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </ResponsiveTable>
        </DialogContentText>
      </ActionDialog>
    </>
  );
};

export default ViewStoreDialog;
